import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsByAgentIdOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
const useAgent = agentId => {
  const $ = _c(5);
  const t0 = agentId ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = getOrgAgentsByAgentIdOptions({
      path: {
        agentId: t0
      }
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!agentId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return useQuery(t3);
};
export default useAgent;